const DASHBOARD_TYPE = {
  YEAR: 1,
  HALF_YEAR: 2,
  QUARTER_YEAR: 3,
  MONTH_YEAR: 4,
};

const getIndexFromStoreData = (dataProps) => {
  const { type, storeData, dataList } = dataProps;
  // define storeData
  // storeData = {
  //   selectedYear: '',
  //   selectedMonthYear: {
  //     month: '',
  //     year: '',
  //   },
  //   selectedHalfYear: {
  //     order: '', order: 1 || 2
  //     year: '',
  //   },
  //   selectedQuarterYear: {
  //     order: '', order: 1 || 2 || 3 || 4
  //     year: '',
  //   },
  // };
  let index = 0;
  if (type === DASHBOARD_TYPE.YEAR) {
    const oldSelected = storeData.selectedYear;
    index = dataList.findIndex((item) => item.year === oldSelected);
  } else if (type === DASHBOARD_TYPE.MONTH_YEAR) {
    const month = storeData.selectedMonthYear.month;
    const year = storeData.selectedMonthYear.year;
    index = dataList.findIndex((item) => item.year === year && item.month === month);
  } else if (type === DASHBOARD_TYPE.HALF_YEAR) {
    // todo
  } else if (type === DASHBOARD_TYPE.QUARTER_YEAR) {
    // todo
  }
  if (index < 0) {
    index = dataList.length - 1;
  }
  return index;
};

export { DASHBOARD_TYPE, getIndexFromStoreData };
